import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import { useQuery } from "react-query";
import useGlobalContext from "hooks/globalData";
import {
  ListRequestOfBaseFilter,
  ResourceType,
} from "services/KnowfullyAdminClient";
import { useIntl } from "react-intl";

type SelectResourceTypeMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
};

const SelectResourceTypeMultiple = ({
  onChange,
  value,
  variant,
}: SelectResourceTypeMultipleProps) => {
  const { skuService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { data, isFetching } = useQuery(["resourceTypes"], () =>
    skuService.getResourceTypes(
      ListRequestOfBaseFilter.fromJS({
        pageSize: -1,
        sortField: "name",
      })
    )
  );

  const handleChangeMultiple = (_: any, values: ResourceType[]) => {
    onChange(values.map((v) => v.id!));
  };

  const resources = data?.data ?? [];

  return (
    <Autocomplete
      multiple
      options={resources}
      getOptionLabel={(option) => option.name ?? "?"}
      value={resources.filter((r) => value.includes(r.id!) ?? false)}
      onChange={handleChangeMultiple}
      loading={isFetching}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "facultyRoles" })}
        />
      )}
    />
  );
};

export default SelectResourceTypeMultiple;
